import draggable from 'vuedraggable'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
import { loading, toast } from '@/shared/utils/UIHelper'
import Roles from '@/shared/utils/roles.js'
import PermissionMixin from '@/store/module/permission/mixin'
import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'
export default {
  name: 'kanban',
  props:
    {
      task: {
        type: Object,
        default: () => ({})
      },
      colunas: {
        type: Array,
        default: []
      },
      altura: {
        type: String,
        default: '500px'
      }
    },
  mixins: [AccountMixin, CompanyMixin, PermissionMixin],
  components: {
    draggable
  },
  mounted () {
  },

  data () {
    return {
      newTask: '',
      taskss: [],
      roles: Roles
    }
  },
  computed: {
  },

  methods: {
    validaNomeUser (data) {
      let limiteCaracter = 19
      if (data.length < limiteCaracter) {
        return data
      } else {
        data = data.substring(0, limiteCaracter + 5) + ' ...'
        return data
      }
    },
    alteracao (e) {
      let data = {
        status: parseInt(e.to.id),
        OcorrenciaId: e.item.id
      }
      if (!this.hasRole(this.roles.RW_REAL_ESTA_USER_OBRA)) {
        loading.push()
        OcurrenceRepository.ChangeKanban(data)
          .then(Response => {
            loading.pop()
            this.$emit('alteracao')
            if (Response.data) {
              toast.success('Ocorrencia alterada com sucesso!')
            }
          })
          .catch(Error => {
            loading.pop()
            this.$emit('alteracao')
            toast.warning(Error.response.data)
          })
      } else {
        toast.warning('Usuario não pode alterar status das ocorrências')
      }
      this.calcularTotalKanban(e)
    },
    clicaritem (tasks) {
      this.$emit('clicaritem', tasks)
    },
    novocard () {
      this.$emit('novocard')
    },
    calcularTotalKanban (e) {
      this.colunas = this.colunas.map((Element) => {
        if (Element.id === e.to.id) {
          Element.qtdOcu = parseInt(Element.qtdOcu)
          Element.qtdOcu++
        }
        if (Element.id === e.from.id) {
          Element.qtdOcu = parseInt(Element.qtdOcu)
          Element.qtdOcu--
        }
        return Element
      })
    },
    agua () {
      alert('teste')
    },
    detalhe (data) {
      this.$emit('detalhe', data)
    },
    handleMove (e) {
      const { index, futureIndex } = e.draggedContext
      this.movingIndex = index
      this.futureIndex = futureIndex
      return false // disable sort
    },
    finish () {
      console.log(this.c.task) // { id: 1, name: 'Item 1' }
    },
    add: function () {
      if (this.newTask) {
        this.arrBackLog.push({ name: this.newTask })
        this.newTask = ''
      }
    },
    onEdit (tasks) {
      this.$emit('editar', tasks)
      // alert(`EDITANDO:  ${tasks.name}`);
    },
    onDelete (tasks) {
      this.$emit('excluir', tasks)
    },
    retornaCor (element) {
      // return element.prioridade
      return `linear-gradient(90deg, ${element.status} 4%, #fff 4%)`
    },
    iconselector (e) {
      if (e === 0) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Infiltracao.svg'
      if (e === 1) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Eletrico.svg'
      if (e === 2) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Pisos_Revestimento.svg'
      if (e === 3) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Esquadrias.svg'
      if (e === 4) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Vedacao.svg'
      if (e === 5) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Pintura.svg'
      if (e === 6) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Loucas.svg'
      if (e === 7) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Hidraulica.svg'
      if (e === 8) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Tubulacoes.svg'
      if (e === 9) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Estrutura.svg'
      if (e === 10) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Impermeabilizacao.svg'
      if (e === 11) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Outros.svg'
    }
  },

  updated () {
  },

  created () {

  }

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/kanban/kanban.js